import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getMataKuliah = 'mata-kuliah';
const getMataKuliahSelect = 'mata-kuliah-select';
const postMataKuliahUrl = 'mata-kuliah';
const putMataKuliah = 'mata-kuliah/';
const deleteMataKuliah = 'mata-kuliah/';

class MataKuliahService {

    postMataKuliah(formData) {
        return axios
            .post(
                API_URL + postMataKuliahUrl,
                formData,
                { headers: authHeader() }
            );
    }

    putMataKuliah(formData) {
        var headers = authHeader();

        return axios
            .put(
                API_URL + putMataKuliah + formData.idMataKuliah, formData,
                { headers: authHeader() }
            );
    }

    deleteMataKuliah(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deleteMataKuliah + formData.idMataKuliah,
                { headers: authHeader() }
            );
    }
    getMataKuliah(currentPage,pageSize,filter){
        
        return axios.get(
            API_URL + getMataKuliah + '?pageNo=' + currentPage + '&pageSize='+pageSize + '&filter='+filter,
            { headers: authHeader() 
        });
    }
    getMataKuliahSelect(){
        
        return axios.get(
            API_URL + getMataKuliahSelect,
            { headers: authHeader() 
        });
    }

}

export default new MataKuliahService();